import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { Button } from '../../../components/ui/Button';
import { Select } from '../../../components/ui/Select';

const FilterControls = ({ onFilterChange, onSortChange, totalEvents, activeFilters }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'pending', label: 'Pending' },
    { value: 'settled', label: 'Settled' }
  ];

  const sortOptions = [
    { value: 'date-desc', label: 'Newest First' },
    { value: 'date-asc', label: 'Oldest First' },
    { value: 'amount-desc', label: 'Highest Amount' },
    { value: 'amount-asc', label: 'Lowest Amount' },
    { value: 'name-asc', label: 'Name A-Z' },
    { value: 'name-desc', label: 'Name Z-A' }
  ];

  const timeRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' }
  ];

  const handleClearFilters = () => {
    onFilterChange({
      status: 'all',
      timeRange: 'all',
      search: ''
    });
    onSortChange('date-desc');
  };

  const hasActiveFilters = activeFilters?.status !== 'all' || 
                          activeFilters?.timeRange !== 'all' || 
                          activeFilters?.search !== '';

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-4">
          <div>
            <h3 className="font-medium text-foreground">Events</h3>
            <p className="text-sm text-muted-foreground">
              {totalEvents} total events
              {hasActiveFilters && (
                <span className="ml-2 px-2 py-1 bg-primary/10 text-primary text-xs rounded-full">
                  Filtered
                </span>
              )}
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          {hasActiveFilters && (
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={handleClearFilters}
              iconName="X"
              iconPosition="left"
            >
              Clear Filters
            </Button>
          )}
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
          >
            {isExpanded ? 'Hide Filters' : 'Show Filters'}
          </Button>
        </div>
      </div>
      {isExpanded && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pt-4 border-t border-border">
          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">Search Events</label>
            <div className="relative">
              <Icon 
                name="Search" 
                size={16} 
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
              />
              <input
                type="text"
                placeholder="Search by name..."
                className="w-full pl-10 pr-4 py-2 border border-border rounded-md bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                value={activeFilters?.search || ''}
                onChange={(e) => onFilterChange({ ...activeFilters, search: e?.target?.value })}
              />
            </div>
          </div>

          <Select
            label="Status"
            options={statusOptions}
            value={activeFilters?.status || 'all'}
            onChange={(value) => onFilterChange({ ...activeFilters, status: value })}
            className="space-y-2"
          />

          <Select
            label="Time Range"
            options={timeRangeOptions}
            value={activeFilters?.timeRange || 'all'}
            onChange={(value) => onFilterChange({ ...activeFilters, timeRange: value })}
            className="space-y-2"
          />

          <Select
            label="Sort By"
            options={sortOptions}
            value={activeFilters?.sortBy || 'date-desc'}
            onChange={(value) => onSortChange(value)}
            className="space-y-2"
          />
        </div>
      )}
    </div>
  );
};

export default FilterControls;
